var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbkhazia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00993e",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 3.43H0v3.43h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 10.29H0v3.42h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 17.14h30v3.43H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8312a",
    d: "M15 0H0v10.29h15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.2 5.68s-.15.06-.05 1.22c.08.96.42 1.27.42 1.27l.15.59h1.4s.03-.36.09-.48c.13-.28.66-.6.89-1.1.24-.3.12-.9.61-1.5.25-.29-.28-.16-.28-.16-.3.2-.44.42-.5.57-.06.3-.29.56-.3.34q.02 0-.34-1.12c-.02-.22-.13-.98-.15-1.56-.02-.38-.35-.4-.38-.02l-.04 1.52-.08-1.76c-.03-.5-.4-.42-.42 0L7.2 5.3l-.07-1.77c-.1-.34-.37-.14-.37.23l-.05 1.72-.07-1.34c0-.24-.29-.22-.32.12-.03.5-.1.9-.12 1.41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m7.07 2.45.43-1.32.43 1.32-1.12-.82h1.38z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.4 2.97-1.12-.81h1.38l-1.12.81.43-1.31z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.51 4.54-1.12-.82h1.39l-1.12.82.42-1.32z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.74 6.74-1.12-.8H14l-1.12.8.43-1.31z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m4.6 2.97 1.12-.81H4.34l1.12.81-.43-1.31z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2.49 4.54 1.12-.82H2.22l1.12.82-.42-1.32z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1.26 6.74 1.12-.8H1l1.12.8-.43-1.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbkhazia);
export default __webpack_public_path__ + "static/media/abkhazia.bd5db231b6637ac74e16634de80f4fe2.svg";
export { ForwardRef as ReactComponent };